import { SpriteMaterial, Sprite, TextureLoader } from 'three'
import TextureAnimator from './TextureAnimator'

export default class Sprite2D extends Sprite {
  constructor(
    id,
    assetName,
    rotation,
    position,
    scale,
    multiple = null,
    customArgsForMaterial = {}
  ) {
    super()

    this._asset = assetName
    this._customArgsMaterial = customArgsForMaterial
    this._position = position
    this._rotation = rotation
    this._scale = scale
    this._onLoaded = () => {}
    this._multiple = multiple
    this._textureAnimator = null
    this._texture = null
    this.name = id
    this._animations = null

    this.load()
  }

  set onLoaded(callback) {
    this._onLoaded = callback
  }
  set assignParentPosition(pos) {
    this.position.set(pos.clone().x, pos.clone().y, pos.clone().z)
  }

  set setAnimations(animations) {
    this._animations = animations
  }

  get getTexture() {
    return this._texture
  }

  get getAnimations() {
    return this._animations
  }

  update(milliSec) {
    if (this._textureAnimator) {
      this._textureAnimator.update(milliSec)
    }
  }

  load() {
    let loader = new TextureLoader()
    let loadTexture = (name) => loader.load(name, () => this._onLoaded())
    let texture = loadTexture(this._asset)

    if (this._multiple) {
      const { horizontalTiles, totalTiles, verticalTiles, tileDuration } = this._multiple
      this._textureAnimator = new TextureAnimator(
        texture,
        horizontalTiles,
        verticalTiles,
        totalTiles,
        tileDuration
      )
    }

    if (texture) {
      this._texture = texture
      let spriteMaterial = new SpriteMaterial({ map: texture, ...this._customArgsMaterial })

      this.material = spriteMaterial
      this.position.set(this._position.x, this._position.y, this._position.z)

      if (this._rotation) {
        this.rotation.x = this._rotation[0]
        this.rotation.y = this._rotation[1]
        this.rotation.z = this._rotation[2]
      }

      if (this._scale) {
        this.scale.set(...this._scale)
      }
    }
  }
}
